import React from 'react'

const styles = {
  h1: {

  },
  h2: {
    textTransform: 'uppercase',
    fontSize: '2.6rem',
    fontWeight: '700',
    fontFamily: 'Titillium  Web',
  },
  h3: {
    textTransform: 'uppercase',
    fontSize: '2.2rem',
    fontWeight: '700',
    fontFamily: 'Titillium  Web',
  },
  h5: {
    textTransform: 'uppercase',
    fontWeight: 'bold',
    fontSize: '1.6rem',
  },
}

const Caption = props => {
  const { as = 'h5', children, extraMarginTop, style: customStyle, ...rest } = props
  const style = Object.assign({}, styles[as], customStyle)
  if (extraMarginTop) style.marginTop = '2rem'
  return React.createElement(as, { ...rest, style }, children)
}

Caption.propTypes = {
}

export default Caption



// WEBPACK FOOTER //
// ./src/browser/components/Caption.js